import { GeneralToggle } from "../../../../general";

const Mode = {
  HISTORY: 'history',
  FAVOURITES: 'favourites',
}

const ModeToggle = ({ mode, setMode }) => {
  return (
    <GeneralToggle 
      label='Mode' 
      value={mode} 
      setValue={setMode}
      items={Object.values(Mode)}
    />
  );
}

export default ModeToggle;

export {
  Mode,
}